import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { useAuth } from '../../../hooks/auth';

import AdminUser from '../pages/AdminUser';
import AlertsHistory from '../pages/AlertsHistory';
import Clients from '../pages/Clients';
import Dashboard from '../pages/Dashboard';
import Devices from '../pages/Devices/routes/index';
import DevicesMonitor from '../pages/DevicesMonitor';
import Roles from '../pages/Roles';
import User from '../pages/User';

const Routes: React.FC = () => {
  const { user } = useAuth();
  
  let userComponent : any;
  if (user.sysadmin || user.permissions?.includes('|level-admin|') || user.permissions?.includes('|level-manager|'))
    userComponent = AdminUser
  else
    userComponent = User

  return (
    <Switch>
      <Route path="/app/user" exact component={userComponent} />
      <Route path="/app/dashboard" exact component={Dashboard} />
      <Route path="/app/monitor" exact component={DevicesMonitor} />
      <Route path="/app/device*" exact component={Devices}/>
      <Route path="/app/clients" exact component={Clients} /> 
      <Route path="/app/roles" exact component={Roles} /> 
      <Route path="/app/alerts" exact component={AlertsHistory} />
    </Switch>
  );
};

export default Routes;
//
